import { render } from "./ChatRoom.vue?vue&type=template&id=15b9dbb0&scoped=true&ts=true"
import script from "./ChatRoom.vue?vue&type=script&lang=ts"
export * from "./ChatRoom.vue?vue&type=script&lang=ts"

import "./ChatRoom.vue?vue&type=style&index=0&id=15b9dbb0&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b9dbb0"]])

export default __exports__